// AUTO-GENERATED - DO NOT EDIT!
import gql from "graphql-tag";
import { useMutation, MutationHookOptions } from "@apollo/client";
import { createAccount, createAccountVariables } from "../types/createAccount";

export const useCreateAccountMutation = (
  opts: MutationHookOptions<createAccount, createAccountVariables>
) => {
  return useMutation<createAccount, createAccountVariables>(
    createAccountMutation,
    opts
  );
};

export const createAccountMutation = gql`
  mutation createAccount(
    $firstName: String
    $lastName: String
    $email: String!
    $password: String!
    $phoneNumber: String
    $consentMarketingPost: Boolean
    $consentMarketingEmail: Boolean
    $referralCodeId: ID
  ) {
    createAccount(
      firstName: $firstName
      lastName: $lastName
      email: $email
      password: $password
      phoneNumber: $phoneNumber
      consentMarketingPost: $consentMarketingPost
      consentMarketingEmail: $consentMarketingEmail
      referralCodeId: $referralCodeId
    ) {
      errors {
        field
        message
      }
      account {
        id
        intercomId
        email
        firstName
        lastName
        intercomUserHash
      }
    }
  }
`;
